import React, { useCallback,  useMemo } from "react";
import { createEditor } from "slate";
import { Slate, Editable, withReact } from "slate-react";
import { withHistory } from "slate-history";
import { Element } from "./elements/element";
import { Leaf } from "./elements/leaf";

import styles from "./ac.module.scss";
import withLayout from "./utils/withlayout";
import withTables from "./utils/withtable";


const KoRichTextEditorReadOnly = ({ className, text, initialValues, onSetEditorValues, onUpdateAttachment, attachments }) => {
  const editor = useMemo(() => withLayout(withTables(withHistory(withReact(createEditor())))), []);

  console.log('initialValues', initialValues);

  const renderElement = useCallback((props) => <Element readOnly={true} attachments={attachments} {...props} />, []);
  const renderLeaf = useCallback((props) => <Leaf {...props} />, []);


  const initial = [
 
    {
      type: "paragraph",
      children: [{ text: text? text : '' }]
    }
  ];

  return (
    <Slate key={JSON.stringify(initialValues)} editor={editor} initialValue={initialValues ? initialValues : initial}>
      <Editable
        className={`${className? className : ''} ${styles.editableWrapper}`}
        renderElement={renderElement}
        renderLeaf={renderLeaf}
        placeholder=""
        spellCheck
        autoFocus
        readOnly
      />
    </Slate>
  );
};

export default KoRichTextEditorReadOnly;
